import SingleUserInformation from 'components/MapoAdministration/components/User/SingleUserInformation';

const ScreenSingleUserInformation = () => {
  return <SingleUserInformation />;
};

export default ScreenSingleUserInformation;
